import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import OneSignal from 'react-onesignal';
import { initTheme } from './lib/themeUtils';

// ============================================================
// Theme Initialization
//
// Reads the saved theme id from localStorage and sets
// data-theme on <html> before the first React render.
//
// This must run before root.render() so the correct CSS
// variables are in place from frame one. Without it, every
// refresh flashes the default pink theme until ThemeSelector
// mounts and its useEffect fires -- noticeably slow on mobile.
// ============================================================
initTheme();

// ============================================================
// OneSignal Initialization
//
// Initializes OneSignal as early as possible so the SDK is
// ready before the user reaches the Settings page.
//
// autoRegister: false means we ask for permission manually
// via the Settings toggle, not with a browser popup on first load.
//
// serviceWorkerPath points to /public/push/onesignal/OneSignalSDKWorker.js
// This subdirectory scope avoids a conflict with the CRA Workbox
// service worker (service-worker.js) which controls root scope (/).
// Both workers previously competed for scope "/" -- only one can
// win, and when CRA's Workbox worker won it swallowed all push
// events before OneSignal could handle them.
//
// serviceWorkerParam.scope must match the subdirectory where the
// file lives. This is the key fix: restricting OneSignal to
// /push/onesignal/ lets CRA's PWA worker keep root scope, while
// OneSignal's worker exclusively handles push events.
//
// NOTE: React.StrictMode has been intentionally removed from this
// file. StrictMode double-invokes renders in development, which
// causes OneSignal.init() to run twice and throw:
//   "SDK already initialized"
// That error breaks the deferred queue and prevents subscribe,
// unsubscribe, and sendTestNotification from ever resolving.
// ============================================================
OneSignal.init({
  appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
  // pull the app ID from .env.local so it never lives in source code
  // add: REACT_APP_ONESIGNAL_APP_ID=your-app-id-here to .env.local

  serviceWorkerPath: 'push/onesignal/OneSignalSDKWorker.js',
  // FIX: points to /public/push/onesignal/OneSignalSDKWorker.js
  // Previously 'OneSignalSDKWorker.js' (root) conflicted with the
  // CRA Workbox worker. Subdirectory placement eliminates the conflict.

  serviceWorkerParam: { scope: '/push/onesignal/' },
  // FIX: scope now matches the subdirectory where the worker lives.
  // Previously '/' caused both service workers to fight for root scope.

  notifyButton: {
    enable: false,
    // disable the floating bell widget -- we use our own toggle in Settings
  },

  allowLocalhostAsSecureOrigin: process.env.NODE_ENV === 'development',
  // allows OneSignal to work on http://localhost during development
  // production (Netlify) uses HTTPS so this has no effect there
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// NOTE: React.StrictMode removed -- see comment above.
root.render(
  <App />
);

serviceWorkerRegistration.register();
reportWebVitals();